import Icon from '@/components/snippets/icon/icon'
import { FilterSelected } from 'libs/athos/components/collection/filters/FilterSelected'
import { useFilters } from 'libs/athos/hooks/useFilters'
import { ImageViewToggleButton } from '@/components/custom-elements/image-view-toggle-button'
import { useEffect, useState } from 'preact/hooks'

const SCROLL_THRESHOLD = 400

export const CollectionToolbar = () => {
  const {
    handleOpenFilters,
    handleClearFilters,
    handleRemoveFilter,
    activeFilters
  } = useFilters()

  const [isScrolledPast, setIsScrolledPast] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolledPast(window.scrollY > SCROLL_THRESHOLD)
    }

    handleScroll()
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleFilterOpen = () => {
    handleOpenFilters()
    document.querySelector('x-modal[data-id="filters"]')?.handleToggle()
  }

  return (
    <div className="collection-toolbar sticky top-full lg:top-header-adapt flex items-center justify-between gap-x-gutter lg:gap-x-1.5 lg:w-full lg:h-[60px] lg:px-margin lg:bg-secondary lg:border-b lg:border-borders-default z-40 transition-all">
      <div className={`lg-max:absolute lg-max:right-margin lg-max:left-1/2 lg-max:bottom-margin flex items-center w-full-marginless lg:w-fit lg-max:-translate-x-1/2 ${isScrolledPast ? '' : 'lg-max:translate-y-full-margin'} transition-all`}>
        <button
          id="toggle-filters"
          className="lg:!hidden btn btn-fill btn-primary btn-m w-full whitespace-nowrap"
          onClick={handleFilterOpen}
          aria-label="Toggle Filters"
        >
          <div class="w-[12px] h-[8px] children:size-full">
            <Icon id="filter" />
          </div>
          <span className="filters__toggle before:content-show">
            Filters & Sort
          </span>
        </button>
        <button
          className="lg-max:!hidden btn btn-text btn-primary btn-s w-fit whitespace-nowrap"
          onClick={handleFilterOpen}
          aria-label="Toggle Filters"
        >
          <span className="filters__toggle before:content-show text-line text-line-large">
            Filters & Sort
          </span>
        </button>
      </div>
      <div className="grow lg-max:hidden flex">
        <FilterSelected activeFilters={activeFilters} onRemove={handleRemoveFilter} onClear={handleClearFilters} />
      </div>
      <div className="lg:shrink-0 hidden lg:flex items-center justify-center">
        <ImageViewToggleButton className="paragraph-xs font-extended font-semibold flex items-center justify-center gap-x-0.25" />
      </div>
    </div>
  )
}
